import React from "react";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import ForgotPassword from "./ForgotPassword";
import NewPasswordRequired from "./NewPasswordRequired";
import SubmitForgotPassword from "./SubmitForgotPassword";
import { Card, Alert } from "antd";
import Verification from "./Verification";
import { getQueryParameters } from "../../utils/query";
import BaseAlphaUI from "../../BaseAlphaUI";

interface Props {
  initialState?: string;
  header?: React.ReactNode;
}

class Authenticator extends React.Component<Props> {
  state = {
    authState: "signIn",
    error: null,
    email: null,
    password: null,
    user: null,
  };

  componentDidMount(): void {
    console.log("component did mount of Authenticator");
    if (this.props.initialState) {
      this.setState({
        authState: this.props.initialState,
      });
    }
    const params = getQueryParameters();
    // Check if this is an invitation
    const appName = BaseAlphaUI.getAppName();
    console.log(
      "loading the app seeing whether it is a invite or not " +
        params.invite_token
    );
    if (params.invite_token && params.type) {
      window.localStorage.setItem(`${appName}InviteToken`, params.invite_token);
      window.localStorage.setItem(`${appName}InviteType`, params.type);
      this.setAuthState("signUp");
    } else if (this.props.initialState !== "checkHatLogin") {
      window.localStorage.removeItem(`${appName}InviteToken`);
      window.localStorage.removeItem(`${appName}InviteType`);
    }
  }

  setAuthState = (newState: string): void => {
    this.setState({ authState: newState });
  };

  setError = (error: string): void => {
    this.setState({ error });
  };

  setEmail = (email: string): void => {
    this.setState({ email });
  };

  setPassword = (password: string): void => {
    this.setState({ password });
  };

  setUser = (user: any): void => {
    this.setState({ user });
  };

  renderComponent(): React.ReactElement {
    const componentsProps = {
      setError: this.setError,
      changeState: this.setAuthState,
      setEmail: this.setEmail,
      setPassword: this.setPassword,
      setUser: this.setUser,
    };
    switch (this.state.authState) {
      case "signIn":
        return <SignIn {...componentsProps} />;
      case "signUp":
        return <SignUp {...componentsProps} />;
      case "forgotPassword":
        return <ForgotPassword {...componentsProps} />;
      case "submitForgotPassword":
        return <SubmitForgotPassword {...componentsProps} />;
      case "newPasswordRequired":
        return (
          <NewPasswordRequired
            {...componentsProps}
            user={this.state.user}
            email={this.state.email}
          />
        );
      case "passwordLogin":
        return <SignIn {...componentsProps} initialLoginType="Password" />;
      case "verificationCode":
        return (
          <Verification
            {...componentsProps}
            email={this.state.email}
            password={this.state.password}
          />
        );
    }
    return <div>Loading ...</div>;
  }

  render(): React.ReactElement {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Card
          style={{
            maxWidth: "300px",
          }}
        >
          {this.props.header}
          {this.state.error && (
            <Alert type="error" message={this.state.error} />
          )}
          {this.renderComponent()}
        </Card>
      </div>
    );
  }
}

export default Authenticator;
